export function keyGenerator(){
    const chars = "ABCDEFGHJKLMNOPQRSTUVWXYZ".split("");
    const numbers = "0123456789".split("");
  
    const size = Array(9);
  
    const arr:String[] = [];
    Array.from(size.keys()).forEach((e) => {
      if (e < 3) {
        var random = Math.floor(Math.random() * chars.length);
        arr.push(chars[random]);
      }  else {
        var randomNumber = Math.floor(Math.random() * numbers.length);
        arr.push(numbers[randomNumber]);
      }
    });
  
    return arr.join("");
  };